import { render, staticRenderFns } from "./FormJobCategory.vue?vue&type=template&id=25c5c9f5&scoped=true&"
import script from "./FormJobCategory.vue?vue&type=script&lang=js&"
export * from "./FormJobCategory.vue?vue&type=script&lang=js&"
import style0 from "./FormJobCategory.vue?vue&type=style&index=0&id=25c5c9f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5c9f5",
  null
  
)

export default component.exports